import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { goodsService } from 'shared/src/api/goodsService';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { useMyInfo } from 'shared/src/queries';
import { isNotNil } from 'shared/src/utils';

export const useBeautyRecommendedOption = () => {
  const goodsSno = useGoodsSno();
  const { data: myInfo } = useMyInfo();

  return useQuery({
    queryKey: queryKey.beautyRecommendedOption(goodsSno),
    queryFn: () => goodsService.getBeautyRecommendedOption(goodsSno),
    enabled: !myInfo.is_anonymous && isNotNil(myInfo.skin_tone),
  });
};
